import {
  BellIcon,
  BoxesIcon,
  CalendarOutlineIcon,
  DocumentInfoOutlineIcon,
  ShieldCheckOutlineIcon,
  TagIcon,
} from "@components/Icons/ForGenesis";

/**
 * Single source of truth for Genesis Sync API paths + v2 module rows.
 * Update endpoints here when BE adds new streams.
 *
 * Query-key helpers in query-key.js:
 *   genesisSyncStreamStart(stream) → `genesis-sync/${stream}/start`
 *   genesisSyncStreamFull(stream)  → `genesis-sync/${stream}/full`
 *   genesisSyncStatus              → `genesis-sync/status`
 *   genesisSyncStart / genesisSyncFull (v1)
 */

export const GENESIS_SYNC_V1 = {
  startPath: "genesis-sync/start",
  fullPath: "genesis-sync/full",
  statusPath: "genesis-sync/status",
};

export const GENESIS_SYNC_V2_MODULES = [
  {
    id: "components",
    labelKey: "preferences.genesis-sync-module-components",
    labelDefault: "Components",
    icon: BoxesIcon,
    iconColor: "#01BBFE",
    actionType: "sync",
    enabled: true,
    statusStreamKey: "components",
    startPath: "genesis-sync/components/start",
    fullPath: "genesis-sync/components/full",
  },
  {
    id: "licenses",
    labelKey: "preferences.genesis-sync-module-licenses",
    labelDefault: "Licenses",
    icon: DocumentInfoOutlineIcon,
    iconColor: "#A78BFA",
    actionType: "sync",
    enabled: true,
    statusStreamKey: "licenses",
    startPath: "genesis-sync/licenses/start",
    fullPath: "genesis-sync/licenses/full",
  },
  {
    id: "license-attributes",
    labelKey: "preferences.genesis-sync-module-license-attributes",
    labelDefault: "License Attributes",
    icon: TagIcon,
    iconColor: "#FBBF24",
    actionType: "sync",
    enabled: true,
    statusStreamKey: "license-attributes",
    startPath: "genesis-sync/license-attributes/start",
    fullPath: "genesis-sync/license-attributes/full",
  },
  {
    id: "license-periods",
    labelKey: "preferences.genesis-sync-module-license-periods",
    labelDefault: "License Periods",
    icon: CalendarOutlineIcon,
    iconColor: "#2DD4BF",
    actionType: "sync",
    enabled: true,
    statusStreamKey: "license-periods",
    startPath: "genesis-sync/license-periods/start",
    fullPath: "genesis-sync/license-periods/full",
  },
  {
    id: "cves",
    labelKey: "preferences.genesis-sync-module-cves",
    labelDefault: "CVEs",
    icon: ShieldCheckOutlineIcon,
    iconColor: "#F87171",
    actionType: "sync",
    enabled: true,
    statusStreamKey: "cves",
    startPath: "genesis-sync/cves/start",
    fullPath: "genesis-sync/cves/full",
  },
  {
    id: "security-alerts",
    labelKey: "preferences.genesis-sync-module-security-alerts",
    labelDefault: "Security Alerts",
    icon: BellIcon,
    iconColor: "#FB923C",
    actionType: "sync",
    enabled: true,
    statusStreamKey: "security-alerts",
    startPath: "genesis-sync/security-alerts/start",
    fullPath: "genesis-sync/security-alerts/full",
  },
];

export const isGenesisV2Enabled = (codeValue) =>
  String(codeValue || "N").toUpperCase() === "Y";
